import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {  Product, InventoryLocation, QtyDetail, LocationQtyDetail } from '../shared';
import { MenuItem } from 'ng2-material-components/ng2-material-components';
import { LocationEditQtyService } from './location-edit-qty.service';

@Component({
    selector: 'location-qty',
    styles: [ require('./location-edit-qty.component.scss') ],
    template: require('./location-edit-qty.component.pug')
})
export class LocationEditQtyComponent {

    @Input() product: Product;
    @Input() location: InventoryLocation;
    @Output() applyChanges = new EventEmitter<InventoryLocation>();

    fg = new FormGroup({});
    callingServer: boolean;
    editActionItems: Array<MenuItem> = [<MenuItem>{icon: 'check'}, <MenuItem>{icon: 'undo'}];


    constructor(
                public _locationEditQtyService: LocationEditQtyService
               ) {
    }

     onEditActionClicked(action: MenuItem, location: InventoryLocation) {
         switch (action.icon) {
                case 'check':
                    this._updateQty();
                    break;
                case 'undo':
                    this._undo();
                    break;
         }
     }

    private _updateQty() {

        let qty = this.fg.controls['qty'].value;

        if (qty) {

            this. callingServer = true;
            let locationQtyDetail = new LocationQtyDetail(
                                                            this.location.id,
                                                            this.product.id,
                                                            new QtyDetail (+qty)
                                                         );
            this._locationEditQtyService.updateQty(locationQtyDetail)
                    .subscribe(
                            res  => {

                                this. callingServer = false;
                                this.location.current = qty;
                                this.location.editMode = false;
                                this.location.updateMissQty(qty);
                                this.applyChanges.emit(this.location);
                            },
                            error => this. callingServer = false
             );
         }
    }

    private _undo() {
        this.location.editMode = false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/location-edit-qty/location-edit-qty.component.ts